import { domMax, m, LazyMotion } from 'framer-motion';
import { ENVIRONMENT } from 'src/config-global';
import { ENVIRONMENTS } from 'src/constants/misc';
import Banner from '../banner';
// ----------------------------------------------------------------------

export type MotionLazyProps = {
  children: React.ReactNode;
  hideBanner?: boolean;
};

export function MotionLazy({ children, hideBanner = false }: MotionLazyProps) {
  return (
    <LazyMotion strict features={domMax}>
      {!hideBanner && <Banner />}
      <m.div
        style={{
          height: '100%',
          marginTop: ENVIRONMENT === ENVIRONMENTS.prod || hideBanner ? 0 : '3.5rem',
        }}
      />
      {children}
    </LazyMotion>
  );
}
